export default __webpack_public_path__ + "static/media/cphLightDark.7d66144c.png";